/** Designer page colour picker — keep in sync with backend HEX_TO_COLOR_NAME_MAP */
export const DESIGNER_COLOR_PICKER_SWATCHES = [
  { hex: "#FF0000", label: "Red" },
  { hex: "#FFA500", label: "Orange" },
  { hex: "#FFFF00", label: "Yellow" },
  { hex: "#008000", label: "Green" },
  { hex: "#00FFFF", label: "Aqua" },
  { hex: "#0047AB", label: "Cobalt" },
  { hex: "#800080", label: "Purple" },
  { hex: "#FFC0CB", label: "Pink" },
  { hex: "#A52A2A", label: "Brown" },
  { hex: "#808000", label: "Olive" },
  { hex: "#FFFFFF", label: "White" },
  { hex: "#F5F5DC", label: "Beige" },
  { hex: "#808080", label: "Grey" },
  { hex: "#000000", label: "Black" },
  { hex: "#C5D3FB", label: "Light Blue" },
  { hex: "#9CCC65", label: "Light Green" },
  { hex: "#C8A97E", label: "Light Brown" },
  { hex: "#6D4C41", label: "Dark Brown" },
] as const;

export const DESIGNER_COLOR_PICKER_PRESET_HEX =
  DESIGNER_COLOR_PICKER_SWATCHES.map(swatch => swatch.hex);
